<template>
  <div>
    <b-field :label="$t('detailCatalogue.comptabilite.compteAnalytique.title')"
             custom-class="has-text-default is-italic has-text-weight-light">
      <span class="has-text-weight-bold">
        {{ compteAnalytique ? compteAnalytique.compteAnalytique : null }}
      </span>
    </b-field>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      compteAnalytique: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    comptesAnalytique() {
      return this.parametre(PARAMETRES_KEYS.compteAnalytique);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.compteAnalytique]);
      if (this.produit.compteAnalytiqueId) {
        this.compteAnalytique = this.comptesAnalytique.find((compte) => {
          return compte.id === this.produit.compteAnalytiqueId;
        });
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
